import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import type { Contact } from 'types/list'
import { listFormStartManagingLists } from '@disco/state-management/actions/EmailGroupActions'
import { getImportedContacts } from '@disco/state-management/selectors/contacts'
import ModalActionDialog from 'components/modals/dialogs/modal-action-dialog'

type OwnProps = {
  params: {
    listId?: string
  }
}

function mapStateToProps(state: any) {
  return {
    importedContacts: getImportedContacts(state),
  }
}

const mapDispatchToProps = {
  listFormStartManagingLists,
}

// Define connector
const connector = connect(mapStateToProps, mapDispatchToProps)

// Infer props type
type PropsFromRedux = ConnectedProps<typeof connector>

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

const ContactImportSuccessDialog: React.FC<Props> = ({
  importedContacts,
  listFormStartManagingLists,
  params,
}) => {
  const navigate = useNavigate()

  const _back = () => {
    const { listId } = params
    navigate(listId ? `/lists/${listId}` : '/contacts/list')
  }

  const _onSecondaryClick = () => {
    _back()
  }

  const _onSubmit = () => {
    _back()

    listFormStartManagingLists(importedContacts, 'SINGLE_LIST')
  }

  const { listId } = params

  if (listId) {
    return (
      <ModalActionDialog
        type="success"
        header="Success!"
        submitButtonCaption="Close"
        onSubmit={_onSubmit}
        onClose={_onSubmit}
      >
        Your contacts have been imported
      </ModalActionDialog>
    )
  } else {
    return (
      <ModalActionDialog
        type="success"
        header="Success!"
        submitButtonCaption="Add contacts to mailing list"
        onSubmit={_onSubmit}
        secondaryButtonCaption="Back to contacts"
        onSecondaryClick={_onSecondaryClick}
        onClose={_onSubmit}
      >
        Your contacts have been imported
      </ModalActionDialog>
    )
  }
}

const ConnectedContactImportSuccessDialog = connector(
  ContactImportSuccessDialog,
)

function ContactImportSuccessDialogWithRouter(props: any) {
  const params = useParams<{ listId?: string }>()

  return <ConnectedContactImportSuccessDialog {...props} params={params} />
}

export default ContactImportSuccessDialogWithRouter
